
import React, { useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import { Button, Col, Input, Row } from 'antd'
import { CONFIG } from '@/config'


const receiver = '亲爱的客户'
const sender = '小芯'
const MakeMessage = React.forwardRef((props: any, ref) => {
    const {
        templateId,
        generate,
        avatarsTabRef,
        setDisabledSubmit
    } = props

    const textAreaRef = useRef<any>()
    const videoModel = templateId === "video1" ? [
        {
            title: '祝新年',
        },
        {
            title: '祝安康',
        },
        {
            title: '自定义',
        },
    ] : templateId === "video2" ? [
        {
            title: '世界杯讲解',
        },
        {
            title: '世界杯赛制',
        },
        {
            title: '自定义',
        },
    ] : [
        {
            title: '送心愿',
        },
        {
            title: '谢陪伴',
        },
        {
            title: '自定义',
        },
    ]
    const [activeCard, setActiveCard] = useState(videoModel.length - 1)

    const onFinished = () => {
        generate({
            "appid": CONFIG.appid,
            "appversion": CONFIG.appversion,
            "sdkversion": CONFIG.sdkversion,
            "template_id": templateId,
            "output": {
                "format": "mp4",
            },
            "template_options": {
                "avatars": [
                    {
                        text: activeCard < cardList.length - 1
                            ? cardList[activeCard]
                            : `${textAreaRef.current?.value}`
                    }
                ],
            }
        })
    }
    const checkoutDisable = () => {
        console.log('textAreaRef.current?.value?.trim().length', textAreaRef.current?.value?.trim().length)
        if (
            avatarsTabRef?.current?.selectedAvatarId &&
            textAreaRef.current?.value?.trim().length
        ) {
            setDisabledSubmit(false)
        } else {
            setDisabledSubmit(true)
        }
    }

    const cardList = useMemo(() => {
        const cardListDraft = templateId === "video1" ? [
            `${receiver} 您好！新的一年，${sender} 为您送上由衷的祝福，祝您新年胜旧年，万事皆可期！`,
            `冬夜褪去，春暖花开。${sender}在此祝福${receiver}，年年幸福年年福，岁岁安康岁岁康！`,
            ``
        ] : templateId === "video2" ? [
            `亲爱的${receiver} 你好，${sender} 来给您讲解，世界杯全称国际足联世界杯，是世界上最高荣誉、最高规格、最高竞技水平、最高知名度的足球比赛，与奥运会并称为全球体育两大最顶级赛事，每四年举办一次`,
            `亲爱的${receiver} 你好，${sender} 来给您讲解，世界杯小组赛采用积分制度，分成8个小组，每组4个队伍，进行一轮循环赛。如果赢了对手，得三分，如果平局两队各积1分。淘汰赛采用单场淘汰制度，两队只比一场比赛，直至决出胜负。`,
            ``
        ] : [
            `烟花向星辰，所愿皆成真。${sender}想和${receiver}一起携手，看一场属于我们的烟花。`,
            `人间烟火气，最抚凡人心。感谢${receiver}，有你陪伴的日子，${sender}觉得比看任何一场绚烂的烟花都来得更幸福。`,
            ``
        ]
        if (activeCard < cardListDraft.length - 1 && textAreaRef.current) {
            textAreaRef.current.value = cardListDraft[activeCard]
        }
        return cardListDraft
    }, [templateId])
    useEffect(() => {
        checkoutDisable()
    }, [activeCard, avatarsTabRef?.current?.selectedAvatarId])

    useImperativeHandle(ref, () => {
        return {
            onFinished
        }
    })

    return (
        <div className='message-field'>
            <Row className='card-list' gutter={16}>
                {
                    cardList.map((card, index) => (
                        <Col
                            span={8}
                            key={card}
                            onClick={() => setActiveCard(index)}
                        >
                            <div className={activeCard === index ? 'active card' : 'card'}>
                                {videoModel[index].title}
                            </div>
                        </Col>
                    ))
                }
            </Row>
            <div className='ans-input'>
                <textarea
                    maxLength={35}
                    placeholder='请输入播报内容，不超过35个字'
                    autoFocus={activeCard === cardList.length - 1}
                    key={activeCard}
                    ref={textAreaRef}
                    defaultValue={cardList[activeCard]}
                    onChange={checkoutDisable}
                />
            </div>
        </div >
    )
})

export default MakeMessage
